import { getInitialState, getPath } from "../../utils";
import ActionTypes from "../actions/ActionTypes";

const initialState = {
  riderPayouts: [],
  activeFilters: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ActionTypes.SET_RIDER_PAYOUTS:
      return setRiderPayouts(state, action);
    case ActionTypes.RESET_STATE_DRIVER_SUPPORT:
      return resetStateDriverSupport(state, action);
    case ActionTypes.SET_ACTIVE_FILTERS_RIDER_PAYOUTS:
      return setActiveFilters(state, action);
    default:
      return state;
  }
}

const setRiderPayouts = (state, action) => {
  return {
    ...state,
    riderPayouts: getPath(action.payload, "data", []),
  };
};

const resetStateDriverSupport = (state, action) => {
  if (action.payload.state) {
    return {
      ...state,
      [action.payload.state]: getInitialState(
        initialState,
        action.payload.state
      ),
    };
  } else {
    return initialState;
  }
};

const setActiveFilters = (state, action) => {
  return {
    ...state,
    activeFilters: action.payload,
  };
};
